import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import SearchBox from 'components/common/SearchBox';
import JobStageModel from 'components/modals/JobStageModel';
import { createJobStageColumns } from 'components/tables/JobStageTable';
import { GET_JOBSTAGE_QUERY } from 'services/api/jobStage';
import { useQuery } from 'react-query';
import { useState, ChangeEvent, useMemo } from 'react';
import { Col, Row, Placeholder, Alert } from 'react-bootstrap';
import { usePermissions } from 'hooks/usePermissions';
import { PERMISSIONS } from 'constants/permissions';
import GTable from 'components/tables/GTable';

const CustomerList = () => {
  const {
    isLoading,
    isError,
    data: stage
  } = useQuery('get_jobStage', GET_JOBSTAGE_QUERY, {
    staleTime: 3 * 60 * 60 * 1000
  });
  const [openJobStageModel, setOpenJobStageModel] = useState<boolean>(false);
  const [search, setSearch] = useState<string>('');

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const [canCreateJobStage, canEditJobStage, canDeleteJobStage] =
    usePermissions([
      PERMISSIONS.JOB_CONFIGURATION.JOB_STAGE.CREATE,
      PERMISSIONS.JOB_CONFIGURATION.JOB_STAGE.UPDATE,
      PERMISSIONS.JOB_CONFIGURATION.JOB_STAGE.DELETE
    ]);

  const jobStageColumns = useMemo(
    () => createJobStageColumns(canEditJobStage, canDeleteJobStage),
    [canEditJobStage, canDeleteJobStage]
  );

  const filteredData = useMemo(() => {
    return stage?.data
      .filter(item => item.name.toLowerCase().includes(search.toLowerCase()))
      .sort((a: any, b: any) => {
        return a?.name?.localeCompare(b?.name ?? '');
      });
  }, [stage?.data, search]);

  return (
    <div>
      <div className="mb-6">
        {isError && (
          <Alert variant="danger">Error fetching job stages: {isError}</Alert>
        )}
        <h2 className="mb-4">All Job Stage</h2>
        <Row className="g-3 justify-content-between mb-4">
          <Col xs="auto">
            {canCreateJobStage && (
              <Button
                variant="primary"
                className="me-4"
                startIcon={<FontAwesomeIcon icon={faPlus} className="me-2" />}
                onClick={() => setOpenJobStageModel(true)}
              >
                Create New Stage
              </Button>
            )}
            <JobStageModel
              show={openJobStageModel}
              handleClose={() => setOpenJobStageModel(false)}
            />
          </Col>
          <Col xs="auto">
            <div className="d-flex">
              <SearchBox
                placeholder="Search by name"
                className="me-2"
                onChange={handleSearchInputChange}
                value={search}
              />
            </div>
          </Col>
        </Row>

        <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white border-top border-bottom border-200 position-relative top-1">
          {isLoading ? (
            <div className="g-3 mt-8 mb-8">
              <Placeholder as="p" animation="glow">
                <Placeholder xs={12} />
              </Placeholder>
              <Placeholder as="p" animation="glow">
                <Placeholder xs={12} />
              </Placeholder>
            </div>
          ) : (
            <GTable
              data={filteredData || []}
              columns={jobStageColumns}
              isLoading={isLoading}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerList;
